import { useReducer } from 'react';

const initialState = {
  activeTab: 'templates',
  selectedTemplate: null,
  selectedColorScheme: 'vibrant',
  previewDevice: 'desktop',
  isLoading: false,
  errors: {},
  hasUnsavedChanges: false,
  showConfirmModal: false,
  pendingTemplate: null,
};

const builderReducer = (state, action) => {
  switch (action.type) {
    case 'SET_TAB':
      return { ...state, activeTab: action.payload };

    case 'SELECT_TEMPLATE':
      return {
        ...state,
        selectedTemplate: action.payload,
        hasUnsavedChanges: true,
      };

    case 'SET_COLOR_SCHEME':
      return {
        ...state,
        selectedColorScheme: action.payload,
        hasUnsavedChanges: true,
      };

    case 'SET_PREVIEW_DEVICE':
      return { ...state, previewDevice: action.payload };

    case 'SET_LOADING':
      return { ...state, isLoading: action.payload };

    case 'SET_ERROR':
      return {
        ...state,
        errors: { ...state.errors, [action.field]: action.message },
      };

    case 'CLEAR_ERROR':
      const newErrors = { ...state.errors };
      delete newErrors[action.field];
      return { ...state, errors: newErrors };

    case 'CLEAR_ERRORS':
      return { ...state, errors: {} };

    case 'MARK_SAVED':
      return { ...state, hasUnsavedChanges: false };

    case 'SHOW_CONFIRM_MODAL':
      return {
        ...state,
        showConfirmModal: true,
        pendingTemplate: action.payload,
      };

    case 'HIDE_CONFIRM_MODAL':
      return {
        ...state,
        showConfirmModal: false,
        pendingTemplate: null,
      };

    case 'MARK_CHANGED':
      return { ...state, hasUnsavedChanges: true };

    default:
      return state;
  }
};

/**
 * Custom hook for managing builder state
 * @param {Object} initialData - Initial state data
 * @returns {Array} [state, dispatch] - State and dispatch function
 */
export const useBuilderState = (initialData = {}) => {
  const [state, dispatch] = useReducer(builderReducer, {
    ...initialState,
    ...initialData,
  });

  return [state, dispatch];
};

